import React from 'react';
import { useAuth } from './auth';
import { Redirect } from 'react-router';
import { Route, useLocation } from 'react-router-dom';
import { useCoopConfig } from './coop-config';
import Loading from '../construction/Loading';

export default function AuthRoute({ path, exact, component, isPublic }) {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const { loadingConfig } = useCoopConfig();

  const isLogin = pathname === '/user/login-v3';

  return (
    <Route
      render={() =>
        isPublic || user || isLogin ? (
          <Route 
            path={path} 
            exact={exact} 
            component={loadingConfig && !isPublic && !isLogin ? Loading : component} 
          />
        ) : (
          <Redirect to="/user/login-v3" />
        )
      }
    />
  );
}
